import { useState, useCallback } from 'react';
import { reservationService } from '../services/reservationService';

export const useReservation = () => {
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(false);

    const getAllReservations = useCallback(async () => {
        try {
            setLoading(true);

            const res = await reservationService.getAllReservations();
            setReservations(res);

            return res;
        } catch (error) {
            console.error('[useReservation] Erreur:', error);
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    const getUserReservations = useCallback(async (userId) => {
        try {
            setLoading(true);
            const res = await reservationService.getUserReservations(userId);
            setReservations(res);
            return res;
        } catch (error) {
            console.error('[useReservation] Erreur:', error);
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    const createReservation = useCallback(async (userId, data) => {
        try {
            setLoading(true);
            const res = await reservationService.createReservation(userId, data);
            setReservations(prev => [...prev, res]);
            return res;
        } catch (error) {
            console.error('[useReservation] Erreur:', error);
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    const updateReservation = useCallback(async (reservationId, data) => {
        try {
            setLoading(true);

            await reservationService.updateReservation(reservationId, data);

            setReservations(prev =>
                prev.map(res =>
                    res.id === reservationId
                        ? { ...res, ...data }
                        : res
                )
            );
        } catch (error) {
            console.error('[useReservation] Erreur:', error);
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    const cancelReservation = useCallback(async (reservationId) => {
        try {
            setLoading(true);
            await reservationService.cancelReservation(reservationId);
            setReservations(prev =>
                prev.map(res =>
                    res.id === reservationId
                        ? { ...res, status: 'annulée' }
                        : res
                )
            );
        } catch (error) {
            console.error('[useReservation] Erreur:', error);
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    // AJOUTER CET ALIAS
    const fetchUserReservations = getUserReservations;

    return {
        reservations,
        loading,
        getAllReservations,
        getUserReservations,
        fetchUserReservations,  // EXPORTER L'ALIAS
        createReservation,
        updateReservation,
        cancelReservation,
    };
};
